/* jshint esversion: 6 */
/* jshint ignore:start */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

const resources = {
  en: {
    translation: {
      "My Booking": "My Booking",
      "Saved Addresses": "Saved Addresses",
      "My Wallet": "My Wallet",
      "Refer & Earn": "Refer & Earn",
      "Contact": "Contact",
      "About": "About",
      "Language": "Language",
      "Privacy Policy": "Privacy Policy",
      "Terms & Condition": "Terms & Condition",
      "Logout": "Logout",
      "Menu": "Menu",
      "Search for product...": "Search for product...",
      "Home services at your": "Home services at your",
      "doorstep": "doorstep",
      "What are you looking for?": "What are you looking for?",
      "Home": "Home",
      "ReachOut max quantity": "ReachOut max quantity",
      "Please select services !!": "Please select services !!",
      "item added": "item added",
      "VIEW CART": "VIEW CART",
      "Customise your service": "Customise your service",
      "Total Price": "Total Price",
      "ADD TO CART": "ADD TO CART",
      "ADD": "ADD",
      "Select a service": "Select a service",
      "Checkout": "Checkout",
      "Please select date and time !!": "Please select date and time !!",
      "Please select payment method !!": "Please select payment method !!",
      "Select Date Of Service": "Select Date Of Service",
      "Select Time Of Service": "Select Time Of Service",
      "No time available !!": "No time available !!",
      "Select Address": "Select Address",
      "Change address": "Change address",
      "Product list": "Product list",
      "Total": "Total",
      "Discount": "Discount",
      "Services list": "Services list",
      "Bill Summary": "Bill Summary",
      "Item total": "Item total",
      "Addon Item total": "Addon Item total",
      "Total pay": "Total pay",
      "Edit service": "Edit service",
      "Proceed to pay": "Proceed to pay",
      "Select Payment Method": "Select Payment Method",
      "CONTINUE": "CONTINUE",
      "Thank you for using our service": "Thank you for using our service",
      "Your service has been booked successfully.": "Your service has been booked successfully.",
      "Our team will reach out to you soon.": "Our team will reach out to you soon.",
      "Continue": "Continue",
      "Payment faild !!": "Payment faild !!",
      "Bookings": "Bookings",
      "You added": "You added",
      "items to booking": "items to booking",
      "Booking id": "Booking id",
      "Booking date": "Booking date",
      "more": "more",
      "Reschedule": "Reschedule",
      "Cancel": "Cancel",
      "Bill Total": "Bill Total",
      "Your Services": "Your Services",
      "Addon List": "Addon List",
      "Time Slot": "Time Slot",
      "SubTotal": "SubTotal",
      "Addon Total": "Addon Total",
      "Booking Details": "Booking Details",
      "Payment Method": "Payment Method",
      "Transaction Id": "Transaction Id",
      "Amount Paid": "Amount Paid",
      "CANCEL SERVICE": "CANCEL SERVICE",
      "Are you sure you want to canceld your service id": "Are you sure you want to canceld your service id",
      "No": "No",
      "Yes": "Yes",
      "Update": "Update",
      "Booking": "Booking",
      "Earn": "Earn",
      "For Each Friend You Refer": "For Each Friend You Refer",
      "Share the Referral Link with Your Friends": "Share the Referral Link with Your Friends",
      "Friend Gets": "Friend Gets",
      "On First Complete Transaction": "On First Complete Transaction",
      "You Get": "You Get",
      "On Your Wallet": "On Your Wallet",
      "Text copied to clipboard !!": "Text copied to clipboard !!",
      "Please fill all details !!": "Please fill all details !!",
      "SELECT": "SELECT",
      "EDIT": "EDIT",
      "ADD NEW ADDRESS": "ADD NEW ADDRESS",
      "New Addresses": "New Addresses",
      "Office": "Office",
      "Other": "Other",
      "Address": "Address",
      "House / Flat / Block No.": "House / Flat / Block No.",
      "Landmark": "Landmark",
      "Search Product": "Search Product",
      "No search data found !!": "No search data found !!",
      "Available Balance": "Available Balance",
      "Income": "Income",
      "Expense": "Expense",
      "Transaction history": "Transaction history",
      "No any transaction history !!": "No any transaction history !!",
      "Logout Successfully !!": "Logout Successfully !!",
      "Service provider information": "Service provider information",
      "Extra Addon": "Extra Addon",
      "Full Name": "Full Name",
      "Mobile Number": "Mobile Number",
      "Email Address": "Email Address",
      "Password": "Password",
      "Enter your full name...": "Enter your full name...",
      "Enter your mobile number...": "Enter your mobile number...",
      "Enter your email Address...": "Enter your email Address...",
      "Enter your password...": "Enter your password...",
      "Address list not found !!": "Address list not found !!",
      "Add Address": "Add Address",
      "Search for your location/society/apartment": "Search for your location/society/apartment",
      "Use current location": "Use current location",
      "Recents": "Recents",
      "We currently do not provide service in your selected area.": "We currently do not provide service in your selected area.",
      "Pages": "Pages",
      "Social links": "Social links",
      "Enable Location Services": "Enable Location Services",
      "To provide accurate services, please enable your location.": "To provide accurate services, please enable your location.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Allow location access when prompted. If not prompted, enable it in your browser settings.",
      "🔄 Refresh the page after enabling.": "🔄 Refresh the page after enabling.",
      "Enable Now": "Enable Now",
      "Wallet Amount": "Wallet Amount",
      "Add Amount": "Add Amount",
      "Enter Amount": "Enter Amount",
      "Please enter amount !!": "Please enter amount !!",
      "Partner Rating": "Partner Rating",
      "Review": "Review",
      "comment...": "comment...",
      "SUBMIT": "SUBMIT",
      "Pay from Wallet": "Pay from Wallet",
      "My Wallet": "My Wallet",
      "Hire Partner": "Hire Partner",
      "Message": "Message",
      "Please write message !!": "Please write message !!",
    }
  },
  ar: {
    translation: {
      "My Booking": "حجزي",
      "Saved Addresses": "العناوين المحفوظة",
      "My Wallet": "محفظتي",
      "Refer & Earn": "دعوة وكسب",
      "Contact": "اتصال",
      "About": "حول",
      "Language": "اللغة",
      "Privacy Policy": "سياسة الخصوصية",
      "Terms & Condition": "الشروط والأحكام",
      "Logout": "تسجيل الخروج",
      "Menu": "القائمة",
      "Search for product...": "ابحث عن منتج...",
      "Home services at your": "خدمات منزلية عند",
      "doorstep": "بابك",
      "What are you looking for?": "ماذا تبحث عنه؟",
      "Home": "الصفحة الرئيسية",
      "ReachOut max quantity": "الحد الأقصى لكمية ReachOut",
      "Please select services !!": "الرجاء اختيار الخدمات !!",
      "item added": "تمت إضافة العنصر",
      "VIEW CART": "عرض العربة",
      "Customise your service": "خصص خدمتك",
      "Total Price": "السعر الإجمالي",
      "ADD TO CART": "إضافة إلى العربة",
      "ADD": "إضافة",
      "Select a service": "اختر خدمة",
      "Checkout": "الدفع",
      "Please select date and time !!": "الرجاء اختيار التاريخ والوقت !!",
      "Please select payment method !!": "الرجاء اختيار طريقة الدفع !!",
      "Select Date Of Service": "حدد تاريخ الخدمة",
      "Select Time Of Service": "حدد وقت الخدمة",
      "No time available !!": "لا يوجد وقت متاح !!",
      "Select Address": "اختر العنوان",
      "Change address": "تغيير العنوان",
      "Product list": "قائمة المنتجات",
      "Total": "الإجمالي",
      "Discount": "الخصم",
      "Services list": "قائمة الخدمات",
      "Bill Summary": "ملخص الفاتورة",
      "Item total": "إجمالي العنصر",
      "Addon Item total": "إجمالي العنصر الإضافي",
      "Total pay": "إجمالي الدفع",
      "Edit service": "تعديل الخدمة",
      "Proceed to pay": "المتابعة للدفع",
      "Select Payment Method": "اختر طريقة الدفع",
      "CONTINUE": "استمر",
      "Thank you for using our service": "شكرًا لاستخدامك خدمتنا",
      "Your service has been booked successfully.": "تم حجز خدمتك بنجاح.",
      "Our team will reach out to you soon.": "سيتواصل معك فريقنا قريبًا.",
      "Continue": "استمر",
      "Payment faild !!": "فشل الدفع !!",
      "Bookings": "الحجوزات",
      "You added": "لقد أضفت",
      "items to booking": "عناصر إلى الحجز",
      "Booking id": "معرف الحجز",
      "Booking date": "تاريخ الحجز",
      "more": "المزيد",
      "Reschedule": "إعادة الجدولة",
      "Cancel": "إلغاء",
      "Bill Total": "إجمالي الفاتورة",
      "Your Services": "خدماتك",
      "Addon List": "قائمة الإضافات",
      "Time Slot": "الفترة الزمنية",
      "SubTotal": "الإجمالي الفرعي",
      "Addon Total": "الإجمالي الإضافي",
      "Booking Details": "تفاصيل الحجز",
      "Payment Method": "طريقة الدفع",
      "Transaction Id": "معرف المعاملة",
      "Amount Paid": "المبلغ المدفوع",
      "CANCEL SERVICE": "إلغاء الخدمة",
      "Are you sure you want to canceld your service id": "هل أنت متأكد أنك تريد إلغاء معرف الخدمة؟",
      "No": "لا",
      "Yes": "نعم",
      "Update": "تحديث",
      "Booking": "الحجز",
      "Earn": "اكسب",
      "For Each Friend You Refer": "لكل صديق تشير إليه",
      "Share the Referral Link with Your Friends": "شارك رابط الإحالة مع أصدقائك",
      "Friend Gets": "الصديق يحصل على",
      "On First Complete Transaction": "عند أول معاملة مكتملة",
      "You Get": "أنت تحصل على",
      "On Your Wallet": "في محفظتك",
      "Text copied to clipboard !!": "تم نسخ النص إلى الحافظة !!",
      "Please fill all details !!": "الرجاء ملء جميع التفاصيل !!",
      "SELECT": "اختر",
      "EDIT": "تعديل",
      "ADD NEW ADDRESS": "إضافة عنوان جديد",
      "New Addresses": "عناوين جديدة",
      "Office": "مكتب",
      "Other": "أخرى",
      "Address": "العنوان",
      "House / Flat / Block No.": "المنزل / الشقة / رقم البلوك",
      "Landmark": "معلم بارز",
      "Search Product": "ابحث عن منتج",
      "No search data found !!": "لم يتم العثور على بيانات البحث !!",
      "Available Balance": "الرصيد المتاح",
      "Income": "الدخل",
      "Expense": "المصروف",
      "Transaction history": "سجل المعاملات",
      "No any transaction history !!": "لا يوجد أي سجل للمعاملات !!",
      "Logout Successfully !!": "تم تسجيل الخروج بنجاح !!",
      "Service provider information": "معلومات مزود الخدمة",
      "Extra Addon": "إضافة إضافية",
      "Full Name": "الاسم الكامل",
      "Mobile Number": "رقم الجوال",
      "Email Address": "عنوان البريد الإلكتروني",
      "Password": "كلمة المرور",
      "Enter your full name...": "أدخل اسمك الكامل...",
      "Enter your mobile number...": "أدخل رقم جوالك...",
      "Enter your email Address...": "أدخل عنوان بريدك الإلكتروني...",
      "Enter your password...": "أدخل كلمة المرور...",
      "Address list not found !!": "قائمة العناوين غير موجودة !!",
      "Add Address": "إضافة عنوان",
      "Search for your location/society/apartment": "ابحث عن موقعك / مجتمعك / شقتك",
      "Use current location": "استخدم الموقع الحالي",
      "Recents": "المواقع الأخيرة",
      "We currently do not provide service in your selected area.": "نحن حالياً لا نقدم الخدمة في منطقتك المحددة.",
      "Pages": "الصفحات",
      "Social links": "الروابط الاجتماعية",
      "Enable Location Services": "تمكين خدمات الموقع",
      "To provide accurate services, please enable your location.": "لتوفير خدمات دقيقة، يرجى تمكين موقعك.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "اسمح بالوصول إلى الموقع عند المطالبة. إذا لم يتم المطالبة، قم بتمكينه في إعدادات المتصفح.",
      "🔄 Refresh the page after enabling.": "🔄 قم بتحديث الصفحة بعد التمكين.",
      "Enable Now": "تمكين الآن",
      "Wallet Amount": "رصيد المحفظة",
      "Add Amount": "إضافة مبلغ",
      "Enter Amount": "أدخل المبلغ",
      "Please enter amount !!": "يرجى إدخال المبلغ !!",
      "Partner Rating": "تقييم الشريك",
      "Review": "مراجعة",
      "comment...": "تعليق...",
      "SUBMIT": "إرسال",
      "Pay from Wallet": "الدفع من المحفظة",
      "My Wallet": "محفظتي",
      "Hire Partner": "توظيف الشريك",
      "Message": "رسالة",
      "Please write message !!": "يرجى كتابة رسالة !!",
    }
  },
  hi: {
    translation: {
      "My Booking": "मेरी बुकिंग",
      "Booking": "बुकिंग",
      "Saved Addresses": "सहेजी गई पते",
      "My Wallet": "मेरा वॉलेट",
      "Refer & Earn": "संदर्भित करें और कमाएं",
      "Contact": "संपर्क करें",
      "About": "हमारे बारे में",
      "Language": "भाषा",
      "Privacy Policy": "गोपनीयता नीति",
      "Terms & Condition": "नियम और शर्तें",
      "Logout": "लॉगआउट",
      "Menu": "मेनू",
      "Search for product...": "उत्पाद के लिए खोजें...",
      "Home services at your": "आपके घर पर सेवाएँ",
      "doorstep": "दरवाजे तक",
      "What are you looking for?": "आप क्या ढूंढ रहे हैं?",
      "Home": "होम",
      "ReachOut max quantity !!": "ReachOut अधिकतम मात्रा !!",
      "Please select services !!": "कृपया सेवाएँ चुनें !!",
      "item added": "आइटम जोड़ा गया",
      "VIEW CART": "कार्ट देखें",
      "Customise your service": "अपनी सेवा कस्टमाइज़ करें",
      "Total Price": "कुल कीमत",
      "ADD TO CART": "कार्ट में डालें",
      "ADD": "जोड़ें",
      "Select a service": "एक सेवा चुनें",
      "Checkout": "चेकआउट",
      "Please select date and time !!": "कृपया दिनांक और समय चुनें !!",
      "Please select payment method !!": "कृपया भुगतान विधि चुनें !!",
      "Select Date Of Service": "सेवा की तिथि चुनें",
      "Select Time Of Service": "सेवा का समय चुनें",
      "No time available !!": "कोई समय उपलब्ध नहीं है !!",
      "Select Address": "पता चुनें",
      "Change address": "पता बदलें",
      "Product list": "उत्पाद सूची",
      "Total": "कुल",
      "Discount": "छूट",
      "Services list": "सेवाओं की सूची",
      "Bill Summary": "बिल सारांश",
      "Item total": "आइटम कुल",
      "Addon Item total": "ऐडऑन आइटम कुल",
      "Total pay": "कुल भुगतान",
      "Edit service": "सेवा संपादित करें",
      "Proceed to pay": "भुगतान के लिए आगे बढ़ें",
      "Select Payment Method": "भुगतान विधि चुनें",
      "CONTINUE": "जारी रखें",
      "Thank you for using our service": "हमारी सेवा का उपयोग करने के लिए धन्यवाद",
      "Your service has been booked successfully.": "आपकी सेवा सफलतापूर्वक बुक हो गई है।",
      "Our team will reach out to you soon.": "हमारी टीम आपसे शीघ्र संपर्क करेगी।",
      "Continue": "जारी रखें",
      "Payment faild !!": "भुगतान असफल रहा !!",
      "Bookings": "बुकिंग्स",
      "You added": "आपने जोड़ा",
      "items to booking": "आइटम्स बुकिंग में",
      "Booking id": "बुकिंग आईडी",
      "Booking date": "बुकिंग तिथि",
      "more": "अधिक",
      "Reschedule": "पुनः शेड्यूल करें",
      "Cancel": "रद्द करें",
      "Bill Total": "कुल बिल",
      "Your Services": "आपकी सेवाएं",
      "Addon List": "एडऑन सूची",
      "Time Slot": "समय स्लॉट",
      "SubTotal": "उप-कुल",
      "Addon Total": "एडऑन कुल",
      "Booking Details": "बुकिंग विवरण",
      "Payment Method": "भुगतान विधि",
      "Transaction Id": "लेन-देन आईडी",
      "Amount Paid": "भुगतान की गई राशि",
      "CANCEL SERVICE": "सेवा रद्द करें",
      "Are you sure you want to cancel your service id": "क्या आप सुनिश्चित हैं कि आप अपनी सेवा आईडी रद्द करना चाहते हैं?",
      "No": "नहीं",
      "Yes": "हां",
      "Update": "अपडेट करें",
      "Earn": "कमाएं",
      "For Each Friend You Refer": "हर मित्र के लिए जिसे आप रेफर करें",
      "Share the Referral Link with Your Friends": "रेफरल लिंक अपने दोस्तों के साथ साझा करें",
      "Friend Gets": "मित्र को मिलेगा",
      "On First Complete Transaction": "पहले पूर्ण लेन-देन पर",
      "You Get": "आपको मिलेगा",
      "On Your Wallet": "आपके वॉलेट में",
      "Text copied to clipboard !!": "टेक्स्ट क्लिपबोर्ड पर कॉपी हो गया !!",
      "SELECT": "चुनें",
      "EDIT": "संपादित करें",
      "ADD NEW ADDRESS": "नया पता जोड़ें",
      "New Addresses": "नए पते",
      "Office": "ऑफिस",
      "Other": "अन्य",
      "Address": "पता",
      "House / Flat / Block No.": "मकान / फ्लैट / ब्लॉक नंबर",
      "Landmark": "प्रमुख स्थान",
      "Search Product": "उत्पाद खोजें",
      "No search data found !!": "कोई खोज परिणाम नहीं मिला !!",
      "Available Balance": "उपलब्ध शेष राशि",
      "Income": "आय",
      "Expense": "व्यय",
      "Transaction history": "लेन-देन इतिहास",
      "No any transaction history !!": "कोई लेन-देन इतिहास नहीं मिला !!",
      "Please fill all details !!": "कृपया सभी विवरण भरें !!",
      "Logout Successfully !!": "सफलतापूर्वक लॉगआउट हो गया !!",
      "Service provider information": "सेवा प्रदाता जानकारी",
      "Extra Addon": "अतिरिक्त ऐड-ऑन",
      "Full Name": "पूरा नाम",
      "Mobile Number": "मोबाइल नंबर",
      "Email Address": "ईमेल पता",
      "Password": "पासवर्ड",
      "Enter your full name...": "अपना पूरा नाम दर्ज करें...",
      "Enter your mobile number...": "अपना मोबाइल नंबर दर्ज करें...",
      "Enter your email Address...": "अपना ईमेल पता दर्ज करें...",
      "Enter your password...": "अपना पासवर्ड दर्ज करें...",
      "Address list not found !!": "पता सूची नहीं मिली !!",
      "Add Address": "पता जोड़ें",
      "Search for your location/society/apartment": "अपना स्थान/समाज/अपार्टमेंट खोजें",
      "Use current location": "वर्तमान स्थान का उपयोग करें",
      "Recents": "हाल के स्थान",
      "We currently do not provide service in your selected area.": "हम फिलहाल आपके चुने हुए क्षेत्र में सेवा प्रदान नहीं करते हैं।",
      "Pages": "पृष्ठ",
      "Social links": "सामाजिक लिंक",
      "Enable Location Services": "स्थान सेवाएँ सक्षम करें",
      "To provide accurate services, please enable your location.": "सटीक सेवाएँ प्रदान करने के लिए, कृपया अपनी स्थिति सक्षम करें।",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "जब पूछा जाए तो स्थान का उपयोग अनुमत करें। यदि नहीं पूछा जाए, तो इसे अपने ब्राउज़र सेटिंग्स में सक्षम करें।",
      "🔄 Refresh the page after enabling.": "🔄 सक्षम करने के बाद पृष्ठ को फिर से लोड करें।",
      "Enable Now": "अब सक्षम करें",
      "Wallet Amount": "वॉलेट राशि",
      "Add Amount": "राशि जोड़ें",
      "Enter Amount": "राशि दर्ज करें",
      "Please enter amount !!": "कृपया राशि दर्ज करें !!",
      "Partner Rating": "पार्टनर रेटिंग",
      "Review": "समीक्षा",
      "comment...": "टिप्पणी...",
      "SUBMIT": "जमा करें",
      "Pay from Wallet": "वॉलेट से भुगतान करें",
      "My Wallet": "मेरा वॉलेट",
      "Hire Partner": "पार्टनर को नियुक्त करें",
      "Message": "संदेश",
      "Please write message !!": "कृपया संदेश लिखें !!"
    }
  },
  sp: {
    translation: {
      "My Booking": "Mi reserva",
      "Saved Addresses": "Direcciones guardadas",
      "My Wallet": "Mi billetera",
      "Refer & Earn": "Recomendar y ganar",
      "Contact": "Contacto",
      "About": "Acerca de",
      "Language": "Idioma",
      "Privacy Policy": "Política de privacidad",
      "Terms & Condition": "Términos y condiciones",
      "Logout": "Cerrar sesión",
      "Menu": "Menú",
      "Search for product...": "Buscar producto...",
      "Home services at your": "Servicios a domicilio en tu",
      "doorstep": "puerta",
      "What are you looking for?": "¿Qué estás buscando?",
      "Home": "Inicio",
      "ReachOut max quantity": "Cantidad máxima alcanzada",
      "Please select services !!": "¡Por favor selecciona los servicios!",
      "item added": "artículo añadido",
      "VIEW CART": "VER CARRITO",
      "Customise your service": "Personaliza tu servicio",
      "Total Price": "Precio total",
      "ADD TO CART": "AÑADIR AL CARRITO",
      "ADD": "AÑADIR",
      "Select a service": "Selecciona un servicio",
      "Checkout": "Pagar",
      "Please select date and time !!": "¡Por favor selecciona la fecha y hora!",
      "Please select payment method !!": "¡Por favor selecciona el método de pago!",
      "Select Date Of Service": "Seleccionar fecha del servicio",
      "Select Time Of Service": "Seleccionar hora del servicio",
      "No time available !!": "¡No hay horario disponible!",
      "Select Address": "Seleccionar dirección",
      "Change address": "Cambiar dirección",
      "Product list": "Lista de productos",
      "Total": "Total",
      "Discount": "Descuento",
      "Services list": "Lista de servicios",
      "Bill Summary": "Resumen de la factura",
      "Item total": "Total del artículo",
      "Addon Item total": "Total del complemento",
      "Total pay": "Pago total",
      "Edit service": "Editar servicio",
      "Proceed to pay": "Proceder al pago",
      "Select Payment Method": "Seleccionar método de pago",
      "CONTINUE": "CONTINUAR",
      "Thank you for using our service": "Gracias por usar nuestro servicio",
      "Your service has been booked successfully.": "Tu servicio ha sido reservado con éxito.",
      "Our team will reach out to you soon.": "Nuestro equipo se pondrá en contacto contigo pronto.",
      "Continue": "Continuar",
      "Payment faild !!": "¡Pago fallido!",
      "Bookings": "Reservas",
      "You added": "Has añadido",
      "items to booking": "artículos a la reserva",
      "Booking id": "ID de reserva",
      "Booking date": "Fecha de reserva",
      "more": "más",
      "Reschedule": "Reprogramar",
      "Cancel": "Cancelar",
      "Bill Total": "Total de la factura",
      "Your Services": "Tus servicios",
      "Addon List": "Lista de complementos",
      "Time Slot": "Franja horaria",
      "SubTotal": "Subtotal",
      "Addon Total": "Total de complementos",
      "Booking Details": "Detalles de la reserva",
      "Payment Method": "Método de pago",
      "Transaction Id": "ID de transacción",
      "Amount Paid": "Monto pagado",
      "CANCEL SERVICE": "CANCELAR SERVICIO",
      "Are you sure you want to canceld your service id": "¿Estás seguro de que deseas cancelar tu servicio con ID?",
      "No": "No",
      "Yes": "Sí",
      "Update": "Actualizar",
      "Booking": "Reserva",
      "Earn": "Ganar",
      "For Each Friend You Refer": "Por cada amigo que refieras",
      "Share the Referral Link with Your Friends": "Comparte el enlace de referencia con tus amigos",
      "Friend Gets": "Tu amigo recibe",
      "On First Complete Transaction": "En su primera transacción completada",
      "You Get": "Tú recibes",
      "On Your Wallet": "En tu billetera",
      "Text copied to clipboard !!": "¡Texto copiado al portapapeles!",
      "Please fill all details !!": "¡Por favor completa todos los detalles!",
      "SELECT": "SELECCIONAR",
      "EDIT": "EDITAR",
      "ADD NEW ADDRESS": "AÑADIR NUEVA DIRECCIÓN",
      "New Addresses": "Nuevas direcciones",
      "Office": "Oficina",
      "Other": "Otro",
      "Address": "Dirección",
      "House / Flat / Block No.": "Casa / Piso / Bloque No.",
      "Landmark": "Punto de referencia",
      "Search Product": "Buscar producto",
      "No search data found !!": "¡No se encontraron datos de búsqueda!",
      "Available Balance": "Saldo disponible",
      "Income": "Ingresos",
      "Expense": "Gastos",
      "Transaction history": "Historial de transacciones",
      "No any transaction history !!": "¡No hay historial de transacciones!",
      "Logout Successfully !!": "¡Cierre de sesión exitoso!",
      "Service provider information": "Información del proveedor de servicios",
      "Extra Addon": "Complemento adicional",
      "Full Name": "Nombre completo",
      "Mobile Number": "Número de móvil",
      "Email Address": "Dirección de correo electrónico",
      "Password": "Contraseña",
      "Enter your full name...": "Ingresa tu nombre completo...",
      "Enter your mobile number...": "Ingresa tu número de móvil...",
      "Enter your email Address...": "Ingresa tu dirección de correo electrónico...",
      "Enter your password...": "Ingresa tu contraseña...",
      "Address list not found !!": "¡Lista de direcciones no encontrada!",
      "Add Address": "Agregar dirección",
      "Search for your location/society/apartment": "Busca tu ubicación/comunidad/apartamento",
      "Use current location": "Usar ubicación actual",
      "Recents": "Recientes",
      "We currently do not provide service in your selected area.": "Actualmente no ofrecemos servicio en el área seleccionada.",
      "Pages": "Páginas",
      "Social links": "Enlaces sociales",
      "Enable Location Services": "Habilitar servicios de ubicación",
      "To provide accurate services, please enable your location.": "Para ofrecer servicios precisos, habilita tu ubicación.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Permite el acceso a la ubicación cuando se te solicite. Si no se te solicita, habilítalo en la configuración de tu navegador.",
      "🔄 Refresh the page after enabling.": "🔄 Actualiza la página después de habilitarlo.",
      "Enable Now": "Habilitar ahora",
      "Wallet Amount": "Saldo de la billetera",
      "Add Amount": "Agregar monto",
      "Enter Amount": "Ingresar monto",
      "Please enter amount !!": "Por favor ingrese el monto !!",
      "Partner Rating": "Calificación del socio",
      "Review": "Reseña",
      "comment...": "comentario...",
      "SUBMIT": "ENVIAR",
      "Pay from Wallet": "Pagar desde la billetera",
      "My Wallet": "Mi billetera",
      "Hire Partner": "Contratar socio",
      "Message": "Mensaje",
      "Please write message !!": "Por favor escriba un mensaje !!"
    }
  },
  fr: {
    translation: {
      "My Booking": "Ma réservation",
      "Saved Addresses": "Adresses enregistrées",
      "My Wallet": "Mon portefeuille",
      "Refer & Earn": "Parrainer et gagner",
      "Contact": "Contact",
      "About": "À propos",
      "Language": "Langue",
      "Privacy Policy": "Politique de confidentialité",
      "Terms & Condition": "Termes et conditions",
      "Logout": "Se déconnecter",
      "Menu": "Menu",
      "Search for product...": "Rechercher un produit...",
      "Home services at your": "Services à domicile à votre",
      "doorstep": "porte",
      "What are you looking for?": "Que cherchez-vous ?",
      "Home": "Accueil",
      "ReachOut max quantity": "Quantité maximale atteinte",
      "Please select services !!": "Veuillez sélectionner les services !!",
      "item added": "article ajouté",
      "VIEW CART": "VOIR LE PANIER",
      "Customise your service": "Personnalisez votre service",
      "Total Price": "Prix total",
      "ADD TO CART": "AJOUTER AU PANIER",
      "ADD": "AJOUTER",
      "Select a service": "Sélectionnez un service",
      "Checkout": "Paiement",
      "Please select date and time !!": "Veuillez sélectionner la date et l'heure !!",
      "Please select payment method !!": "Veuillez sélectionner le mode de paiement !!",
      "Select Date Of Service": "Sélectionnez la date du service",
      "Select Time Of Service": "Sélectionnez l'heure du service",
      "No time available !!": "Aucune heure disponible !!",
      "Select Address": "Sélectionnez l'adresse",
      "Change address": "Changer d'adresse",
      "Product list": "Liste des produits",
      "Total": "Total",
      "Discount": "Réduction",
      "Services list": "Liste des services",
      "Bill Summary": "Résumé de la facture",
      "Item total": "Total de l'article",
      "Addon Item total": "Total des suppléments",
      "Total pay": "Paiement total",
      "Edit service": "Modifier le service",
      "Proceed to pay": "Procéder au paiement",
      "Select Payment Method": "Sélectionnez le mode de paiement",
      "CONTINUE": "CONTINUER",
      "Thank you for using our service": "Merci d'utiliser notre service",
      "Your service has been booked successfully.": "Votre service a été réservé avec succès.",
      "Our team will reach out to you soon.": "Notre équipe vous contactera bientôt.",
      "Continue": "Continuer",
      "Payment faild !!": "Échec du paiement !!",
      "Bookings": "Réservations",
      "You added": "Vous avez ajouté",
      "items to booking": "articles à la réservation",
      "Booking id": "ID de réservation",
      "Booking date": "Date de réservation",
      "more": "plus",
      "Reschedule": "Reprogrammer",
      "Cancel": "Annuler",
      "Bill Total": "Total de la facture",
      "Your Services": "Vos services",
      "Addon List": "Liste des suppléments",
      "Time Slot": "Créneau horaire",
      "SubTotal": "Sous-total",
      "Addon Total": "Total des suppléments",
      "Booking Details": "Détails de la réservation",
      "Payment Method": "Mode de paiement",
      "Transaction Id": "ID de transaction",
      "Amount Paid": "Montant payé",
      "CANCEL SERVICE": "ANNULER LE SERVICE",
      "Are you sure you want to canceld your service id": "Êtes-vous sûr de vouloir annuler votre service avec l'ID",
      "No": "Non",
      "Yes": "Oui",
      "Update": "Mettre à jour",
      "Booking": "Réservation",
      "Earn": "Gagner",
      "For Each Friend You Refer": "Pour chaque ami que vous parrainez",
      "Share the Referral Link with Your Friends": "Partagez le lien de parrainage avec vos amis",
      "Friend Gets": "L'ami reçoit",
      "On First Complete Transaction": "Lors de la première transaction complète",
      "You Get": "Vous recevez",
      "On Your Wallet": "Sur votre portefeuille",
      "Text copied to clipboard !!": "Texte copié dans le presse-papiers !!",
      "Please fill all details !!": "Veuillez remplir tous les détails !!",
      "SELECT": "SÉLECTIONNER",
      "EDIT": "MODIFIER",
      "ADD NEW ADDRESS": "AJOUTER UNE NOUVELLE ADRESSE",
      "New Addresses": "Nouvelles adresses",
      "Office": "Bureau",
      "Other": "Autre",
      "Address": "Adresse",
      "House / Flat / Block No.": "Maison / Appartement / Bloc n°",
      "Landmark": "Point de repère",
      "Search Product": "Rechercher un produit",
      "No search data found !!": "Aucune donnée trouvée !!",
      "Available Balance": "Solde disponible",
      "Income": "Revenu",
      "Expense": "Dépense",
      "Transaction history": "Historique des transactions",
      "No any transaction history !!": "Aucun historique de transaction !!",
      "Logout Successfully !!": "Déconnexion réussie !!",
      "Service provider information": "Informations sur le prestataire de services",
      "Extra Addon": "Supplément supplémentaire",
      "Full Name": "Nom complet",
      "Mobile Number": "Numéro de mobile",
      "Email Address": "Adresse e-mail",
      "Password": "Mot de passe",
      "Enter your full name...": "Entrez votre nom complet...",
      "Enter your mobile number...": "Entrez votre numéro de mobile...",
      "Enter your email Address...": "Entrez votre adresse e-mail...",
      "Enter your password...": "Entrez votre mot de passe...",
      "Address list not found !!": "Liste d'adresses introuvable !!",
      "Add Address": "Ajouter une adresse",
      "Search for your location/society/apartment": "Recherchez votre emplacement/société/appartement",
      "Use current location": "Utiliser la position actuelle",
      "Recents": "Récents",
      "We currently do not provide service in your selected area.": "Nous ne fournissons actuellement pas de service dans la zone sélectionnée.",
      "Pages": "Pages",
      "Social links": "Liens sociaux",
      "Enable Location Services": "Activer les services de localisation",
      "To provide accurate services, please enable your location.": "Pour fournir des services précis, veuillez activer votre localisation.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Autorisez l’accès à la localisation lorsqu’il est demandé. Si ce n’est pas le cas, activez-le dans les paramètres de votre navigateur.",
      "🔄 Refresh the page after enabling.": "🔄 Actualisez la page après l’activation.",
      "Enable Now": "Activer maintenant",
      "Wallet Amount": "Montant du portefeuille",
      "Add Amount": "Ajouter un montant",
      "Enter Amount": "Entrer le montant",
      "Please enter amount !!": "Veuillez entrer le montant !!",
      "Partner Rating": "Évaluation du partenaire",
      "Review": "Avis",
      "comment...": "commentaire...",
      "SUBMIT": "SOUMETTRE",
      "Pay from Wallet": "Payer depuis le portefeuille",
      "My Wallet": "Mon portefeuille",
      "Hire Partner": "Engager un partenaire",
      "Message": "Message",
      "Please write message !!": "Veuillez écrire un message !!"
    }
  },
  ge: {
    translation: {
      "My Booking": "Meine Buchung",
      "Saved Addresses": "Gespeicherte Adressen",
      "My Wallet": "Mein Wallet",
      "Refer & Earn": "Empfehlen und verdienen",
      "Contact": "Kontakt",
      "About": "Über uns",
      "Language": "Sprache",
      "Privacy Policy": "Datenschutzrichtlinie",
      "Terms & Condition": "Allgemeine Geschäftsbedingungen",
      "Logout": "Abmelden",
      "Menu": "Menü",
      "Search for product...": "Nach Produkt suchen...",
      "Home services at your": "Haushaltsdienste an Ihrer",
      "doorstep": "Haustür",
      "What are you looking for?": "Wonach suchen Sie?",
      "Home": "Startseite",
      "ReachOut max quantity": "Maximale Menge erreicht",
      "Please select services !!": "Bitte wählen Sie Dienstleistungen aus!!",
      "item added": "Artikel hinzugefügt",
      "VIEW CART": "WARENKORB ANZEIGEN",
      "Customise your service": "Passen Sie Ihren Service an",
      "Total Price": "Gesamtpreis",
      "ADD TO CART": "IN DEN WARENKORB",
      "ADD": "HINZUFÜGEN",
      "Select a service": "Dienst auswählen",
      "Checkout": "Zur Kasse",
      "Please select date and time !!": "Bitte Datum und Uhrzeit auswählen!!",
      "Please select payment method !!": "Bitte Zahlungsmethode auswählen!!",
      "Select Date Of Service": "Servicedatum auswählen",
      "Select Time Of Service": "Servicezeit auswählen",
      "No time available !!": "Keine Zeit verfügbar!!",
      "Select Address": "Adresse auswählen",
      "Change address": "Adresse ändern",
      "Product list": "Produktliste",
      "Total": "Gesamt",
      "Discount": "Rabatt",
      "Services list": "Dienstleistungsliste",
      "Bill Summary": "Rechnungsübersicht",
      "Item total": "Artikel gesamt",
      "Addon Item total": "Zusatzartikel gesamt",
      "Total pay": "Gesamtzahlung",
      "Edit service": "Service bearbeiten",
      "Proceed to pay": "Zur Zahlung fortfahren",
      "Select Payment Method": "Zahlungsmethode auswählen",
      "CONTINUE": "FORTFAHREN",
      "Thank you for using our service": "Danke, dass Sie unseren Service nutzen",
      "Your service has been booked successfully.": "Ihr Service wurde erfolgreich gebucht.",
      "Our team will reach out to you soon.": "Unser Team wird sich bald mit Ihnen in Verbindung setzen.",
      "Continue": "Weiter",
      "Payment faild !!": "Zahlung fehlgeschlagen!!",
      "Bookings": "Buchungen",
      "You added": "Sie haben hinzugefügt",
      "items to booking": "Artikel zur Buchung",
      "Booking id": "Buchungs-ID",
      "Booking date": "Buchungsdatum",
      "more": "mehr",
      "Reschedule": "Neu planen",
      "Cancel": "Abbrechen",
      "Bill Total": "Rechnung gesamt",
      "Your Services": "Ihre Dienstleistungen",
      "Addon List": "Zusatzliste",
      "Time Slot": "Zeitfenster",
      "SubTotal": "Zwischensumme",
      "Addon Total": "Gesamtzusätze",
      "Booking Details": "Buchungsdetails",
      "Payment Method": "Zahlungsmethode",
      "Transaction Id": "Transaktions-ID",
      "Amount Paid": "Bezahlter Betrag",
      "CANCEL SERVICE": "SERVICE STORNIEREN",
      "Are you sure you want to canceld your service id": "Sind Sie sicher, dass Sie Ihren Service stornieren möchten (ID)?",
      "No": "Nein",
      "Yes": "Ja",
      "Update": "Aktualisieren",
      "Booking": "Buchung",
      "Earn": "Verdienen",
      "For Each Friend You Refer": "Für jeden Freund, den Sie empfehlen",
      "Share the Referral Link with Your Friends": "Teilen Sie den Empfehlungslink mit Ihren Freunden",
      "Friend Gets": "Freund erhält",
      "On First Complete Transaction": "Bei der ersten abgeschlossenen Transaktion",
      "You Get": "Sie erhalten",
      "On Your Wallet": "Auf Ihr Wallet",
      "Text copied to clipboard !!": "Text in Zwischenablage kopiert!!",
      "Please fill all details !!": "Bitte füllen Sie alle Details aus!!",
      "SELECT": "AUSWÄHLEN",
      "EDIT": "BEARBEITEN",
      "ADD NEW ADDRESS": "NEUE ADRESSE HINZUFÜGEN",
      "New Addresses": "Neue Adressen",
      "Office": "Büro",
      "Other": "Andere",
      "Address": "Adresse",
      "House / Flat / Block No.": "Haus / Wohnung / Block Nr.",
      "Landmark": "Wahrzeichen",
      "Search Product": "Produkt suchen",
      "No search data found !!": "Keine Suchdaten gefunden!!",
      "Available Balance": "Verfügbares Guthaben",
      "Income": "Einkommen",
      "Expense": "Ausgabe",
      "Transaction history": "Transaktionsverlauf",
      "No any transaction history !!": "Kein Transaktionsverlauf vorhanden!!",
      "Logout Successfully !!": "Erfolgreich abgemeldet!!",
      "Service provider information": "Informationen zum Dienstanbieter",
      "Extra Addon": "Zusätzliche Erweiterung",
      "Full Name": "Vollständiger Name",
      "Mobile Number": "Handynummer",
      "Email Address": "E-Mail-Adresse",
      "Password": "Passwort",
      "Enter your full name...": "Geben Sie Ihren vollständigen Namen ein...",
      "Enter your mobile number...": "Geben Sie Ihre Handynummer ein...",
      "Enter your email Address...": "Geben Sie Ihre E-Mail-Adresse ein...",
      "Enter your password...": "Geben Sie Ihr Passwort ein...",
      "Address list not found !!": "Adressliste nicht gefunden!!",
      "Add Address": "Adresse hinzufügen",
      "Search for your location/society/apartment": "Suche nach deinem Standort/Wohngebiet/Wohnung",
      "Use current location": "Aktuellen Standort verwenden",
      "Recents": "Zuletzt verwendet",
      "We currently do not provide service in your selected area.": "Wir bieten derzeit keinen Service in dem von dir gewählten Gebiet an.",
      "Pages": "Seiten",
      "Social links": "Soziale Links",
      "Enable Location Services": "Standortdienste aktivieren",
      "To provide accurate services, please enable your location.": "Um genaue Dienste bereitzustellen, bitte deinen Standort aktivieren.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Erlaube den Standortzugriff, wenn du dazu aufgefordert wirst. Wenn keine Aufforderung erscheint, aktiviere ihn in den Browser-Einstellungen.",
      "🔄 Refresh the page after enabling.": "🔄 Aktualisiere die Seite nach der Aktivierung.",
      "Enable Now": "Jetzt aktivieren",
      "Wallet Amount": "Guthaben der Wallet",
      "Add Amount": "Betrag hinzufügen",
      "Enter Amount": "Betrag eingeben",
      "Please enter amount !!": "Bitte Betrag eingeben !!",
      "Partner Rating": "Partnerbewertung",
      "Review": "Bewertung",
      "comment...": "Kommentar...",
      "SUBMIT": "ABSENDEN",
      "Pay from Wallet": "Aus der Wallet bezahlen",
      "My Wallet": "Meine Wallet",
      "Hire Partner": "Partner beauftragen",
      "Message": "Nachricht",
      "Please write message !!": "Bitte Nachricht schreiben !!"
    }
  },
  in: {
    translation: {
      "My Booking": "Pemesanan Saya",
      "Saved Addresses": "Alamat Tersimpan",
      "My Wallet": "Dompet Saya",
      "Refer & Earn": "Ajak Teman & Dapatkan",
      "Contact": "Kontak",
      "About": "Tentang",
      "Language": "Bahasa",
      "Privacy Policy": "Kebijakan Privasi",
      "Terms & Condition": "Syarat & Ketentuan",
      "Logout": "Keluar",
      "Menu": "Menu",
      "Search for product...": "Cari produk...",
      "Home services at your": "Layanan rumah di",
      "doorstep": "depan pintu Anda",
      "What are you looking for?": "Apa yang Anda cari?",
      "Home": "Beranda",
      "ReachOut max quantity": "Jumlah maksimum tercapai",
      "Please select services !!": "Silakan pilih layanan!!",
      "item added": "item ditambahkan",
      "VIEW CART": "LIHAT KERANJANG",
      "Customise your service": "Sesuaikan layanan Anda",
      "Total Price": "Total Harga",
      "ADD TO CART": "TAMBAHKAN KE KERANJANG",
      "ADD": "TAMBAH",
      "Select a service": "Pilih layanan",
      "Checkout": "Pembayaran",
      "Please select date and time !!": "Silakan pilih tanggal dan waktu!!",
      "Please select payment method !!": "Silakan pilih metode pembayaran!!",
      "Select Date Of Service": "Pilih Tanggal Layanan",
      "Select Time Of Service": "Pilih Waktu Layanan",
      "No time available !!": "Tidak ada waktu tersedia!!",
      "Select Address": "Pilih Alamat",
      "Change address": "Ubah alamat",
      "Product list": "Daftar produk",
      "Total": "Total",
      "Discount": "Diskon",
      "Services list": "Daftar layanan",
      "Bill Summary": "Ringkasan Tagihan",
      "Item total": "Total item",
      "Addon Item total": "Total tambahan item",
      "Total pay": "Total pembayaran",
      "Edit service": "Edit layanan",
      "Proceed to pay": "Lanjutkan ke pembayaran",
      "Select Payment Method": "Pilih Metode Pembayaran",
      "CONTINUE": "LANJUTKAN",
      "Thank you for using our service": "Terima kasih telah menggunakan layanan kami",
      "Your service has been booked successfully.": "Layanan Anda berhasil dipesan.",
      "Our team will reach out to you soon.": "Tim kami akan segera menghubungi Anda.",
      "Continue": "Lanjutkan",
      "Payment faild !!": "Pembayaran gagal!!",
      "Bookings": "Pemesanan",
      "You added": "Anda menambahkan",
      "items to booking": "item ke pemesanan",
      "Booking id": "ID Pemesanan",
      "Booking date": "Tanggal Pemesanan",
      "more": "selengkapnya",
      "Reschedule": "Jadwal ulang",
      "Cancel": "Batalkan",
      "Bill Total": "Total Tagihan",
      "Your Services": "Layanan Anda",
      "Addon List": "Daftar Tambahan",
      "Time Slot": "Waktu",
      "SubTotal": "Subtotal",
      "Addon Total": "Total Tambahan",
      "Booking Details": "Detail Pemesanan",
      "Payment Method": "Metode Pembayaran",
      "Transaction Id": "ID Transaksi",
      "Amount Paid": "Jumlah Dibayar",
      "CANCEL SERVICE": "BATALKAN LAYANAN",
      "Are you sure you want to canceld your service id": "Apakah Anda yakin ingin membatalkan layanan Anda dengan ID",
      "No": "Tidak",
      "Yes": "Ya",
      "Update": "Perbarui",
      "Booking": "Pemesanan",
      "Earn": "Dapatkan",
      "For Each Friend You Refer": "Untuk setiap teman yang Anda ajak",
      "Share the Referral Link with Your Friends": "Bagikan tautan referensi dengan teman Anda",
      "Friend Gets": "Teman Mendapat",
      "On First Complete Transaction": "Pada transaksi pertama yang selesai",
      "You Get": "Anda Mendapat",
      "On Your Wallet": "Di Dompet Anda",
      "Text copied to clipboard !!": "Teks disalin ke papan klip!!",
      "Please fill all details !!": "Silakan isi semua detail!!",
      "SELECT": "PILIH",
      "EDIT": "EDIT",
      "ADD NEW ADDRESS": "TAMBAH ALAMAT BARU",
      "New Addresses": "Alamat Baru",
      "Office": "Kantor",
      "Other": "Lainnya",
      "Address": "Alamat",
      "House / Flat / Block No.": "Rumah / Apartemen / Blok No.",
      "Landmark": "Tanda Pengenal",
      "Search Product": "Cari Produk",
      "No search data found !!": "Tidak ada data ditemukan!!",
      "Available Balance": "Saldo Tersedia",
      "Income": "Pemasukan",
      "Expense": "Pengeluaran",
      "Transaction history": "Riwayat Transaksi",
      "No any transaction history !!": "Tidak ada riwayat transaksi!!",
      "Logout Successfully !!": "Berhasil keluar!!",
      "Service provider information": "Informasi penyedia layanan",
      "Extra Addon": "Tambahan Ekstra",
      "Full Name": "Nama Lengkap",
      "Mobile Number": "Nomor Handphone",
      "Email Address": "Alamat Email",
      "Password": "Kata Sandi",
      "Enter your full name...": "Masukkan nama lengkap Anda...",
      "Enter your mobile number...": "Masukkan nomor handphone Anda...",
      "Enter your email Address...": "Masukkan alamat email Anda...",
      "Enter your password...": "Masukkan kata sandi Anda...",
      "Address list not found !!": "Daftar alamat tidak ditemukan!!",
      "Add Address": "Tambah Alamat",
      "Search for your location/society/apartment": "Cari lokasi/komunitas/apartemen Anda",
      "Use current location": "Gunakan lokasi saat ini",
      "Recents": "Terbaru",
      "We currently do not provide service in your selected area.": "Saat ini kami tidak menyediakan layanan di area yang Anda pilih.",
      "Pages": "Halaman",
      "Social links": "Tautan sosial",
      "Enable Location Services": "Aktifkan Layanan Lokasi",
      "To provide accurate services, please enable your location.": "Untuk memberikan layanan yang akurat, harap aktifkan lokasi Anda.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Izinkan akses lokasi saat diminta. Jika tidak diminta, aktifkan di pengaturan browser Anda.",
      "🔄 Refresh the page after enabling.": "🔄 Segarkan halaman setelah mengaktifkan.",
      "Enable Now": "Aktifkan Sekarang",
      "Wallet Amount": "Saldo Dompet",
      "Add Amount": "Tambah Saldo",
      "Enter Amount": "Masukkan Jumlah",
      "Please enter amount !!": "Silakan masukkan jumlah !!",
      "Partner Rating": "Penilaian Mitra",
      "Review": "Ulasan",
      "comment...": "komentar...",
      "SUBMIT": "KIRIM",
      "Pay from Wallet": "Bayar dari Dompet",
      "My Wallet": "Dompet Saya",
      "Hire Partner": "Sewa Mitra",
      "Message": "Pesan",
      "Please write message !!": "Silakan tulis pesan !!"
    }
  },
  sa: {
    translation: {
      "My Booking": "My Bespreking",
      "Saved Addresses": "Gestoorde Adresse",
      "My Wallet": "My Beursie",
      "Refer & Earn": "Verwys en Verdien",
      "Contact": "Kontak",
      "About": "Oor",
      "Language": "Taal",
      "Privacy Policy": "Privaatheidsbeleid",
      "Terms & Condition": "Bepalings en Voorwaardes",
      "Logout": "Teken uit",
      "Menu": "Kieslys",
      "Search for product...": "Soek vir produk...",
      "Home services at your": "Huishoudelike dienste by jou",
      "doorstep": "voordeur",
      "What are you looking for?": "Waarna soek jy?",
      "Home": "Tuis",
      "ReachOut max quantity": "Maksimum hoeveelheid bereik",
      "Please select services !!": "Kies asseblief dienste!!",
      "item added": "item bygevoeg",
      "VIEW CART": "SIEN MANDJIE",
      "Customise your service": "Pas jou diens aan",
      "Total Price": "Totale Prys",
      "ADD TO CART": "VOEG BY MANDJIE",
      "ADD": "VOEG BY",
      "Select a service": "Kies 'n diens",
      "Checkout": "Betaal",
      "Please select date and time !!": "Kies asseblief datum en tyd!!",
      "Please select payment method !!": "Kies asseblief betaalmetode!!",
      "Select Date Of Service": "Kies Diensdatum",
      "Select Time Of Service": "Kies Dienstyd",
      "No time available !!": "Geen tyd beskikbaar nie!!",
      "Select Address": "Kies Adres",
      "Change address": "Verander adres",
      "Product list": "Produkte lys",
      "Total": "Totaal",
      "Discount": "Afslag",
      "Services list": "Dienste lys",
      "Bill Summary": "Rekening Opsomming",
      "Item total": "Item totaal",
      "Addon Item total": "Byvoeging Item totaal",
      "Total pay": "Totale betaling",
      "Edit service": "Wysig diens",
      "Proceed to pay": "Gaan voort om te betaal",
      "Select Payment Method": "Kies Betaalmetode",
      "CONTINUE": "GAAN VOORT",
      "Thank you for using our service": "Dankie dat jy ons diens gebruik",
      "Your service has been booked successfully.": "Jou diens is suksesvol bespreek.",
      "Our team will reach out to you soon.": "Ons span sal binnekort met jou kontak maak.",
      "Continue": "Gaan voort",
      "Payment faild !!": "Betaling het misluk!!",
      "Bookings": "Besprekings",
      "You added": "Jy het bygevoeg",
      "items to booking": "items by bespreking",
      "Booking id": "Besprekings-ID",
      "Booking date": "Besprekingsdatum",
      "more": "meer",
      "Reschedule": "Herskeduleer",
      "Cancel": "Kanselleer",
      "Bill Total": "Totale Rekening",
      "Your Services": "Jou Dienste",
      "Addon List": "Byvoegingslys",
      "Time Slot": "Tydgleuf",
      "SubTotal": "Subtotaal",
      "Addon Total": "Totale Byvoeging",
      "Booking Details": "Besprekingsbesonderhede",
      "Payment Method": "Betaalmetode",
      "Transaction Id": "Transaksie-ID",
      "Amount Paid": "Bedrag Betaal",
      "CANCEL SERVICE": "KANSELLEER DIENS",
      "Are you sure you want to canceld your service id": "Is jy seker jy wil jou diens-ID kanselleer?",
      "No": "Nee",
      "Yes": "Ja",
      "Update": "Werk op",
      "Booking": "Bespreking",
      "Earn": "Verdien",
      "For Each Friend You Refer": "Vir elke vriend wat jy verwys",
      "Share the Referral Link with Your Friends": "Deel die verwysingskakel met jou vriende",
      "Friend Gets": "Vriend Kry",
      "On First Complete Transaction": "Op eerste voltooide transaksie",
      "You Get": "Jy Kry",
      "On Your Wallet": "Op jou Beursie",
      "Text copied to clipboard !!": "Teks na knipbord gekopieer!!",
      "Please fill all details !!": "Vul asseblief alle besonderhede in!!",
      "SELECT": "KIES",
      "EDIT": "WYSIG",
      "ADD NEW ADDRESS": "VOEG NUWE ADRES BY",
      "New Addresses": "Nuwe Adresse",
      "Office": "Kantoor",
      "Other": "Ander",
      "Address": "Adres",
      "House / Flat / Block No.": "Huis / Woonstel / Blok Nr.",
      "Landmark": "Landmerk",
      "Search Product": "Soek Produk",
      "No search data found !!": "Geen soekdata gevind nie!!",
      "Available Balance": "Beskikbare Balans",
      "Income": "Inkomste",
      "Expense": "Uitgawe",
      "Transaction history": "Transaksiegeskiedenis",
      "No any transaction history !!": "Geen transaksiegeskiedenis beskikbaar nie!!",
      "Logout Successfully !!": "Suksesvol uitgeteken!!",
      "Service provider information": "Inligting oor diensverskaffer",
      "Extra Addon": "Ekstra Byvoeging",
      "Full Name": "Volledige Naam",
      "Mobile Number": "Selfoonnommer",
      "Email Address": "E-posadres",
      "Password": "Wagwoord",
      "Enter your full name...": "Voer jou volle naam in...",
      "Enter your mobile number...": "Voer jou selfoonnommer in...",
      "Enter your email Address...": "Voer jou e-posadres in...",
      "Enter your password...": "Voer jou wagwoord in...",
      "Address list not found !!": "Adreslys nie gevind nie!!",
      "Add Address": "Voeg adres by",
      "Search for your location/society/apartment": "Soek jou ligging/gemeenskap/woonstel",
      "Use current location": "Gebruik huidige ligging",
      "Recents": "Onlangs",
      "We currently do not provide service in your selected area.": "Ons bied tans nie diens in jou gekose area nie.",
      "Pages": "Bladsye",
      "Social links": "Sosiale skakels",
      "Enable Location Services": "Skakel Liggingdienste aan",
      "To provide accurate services, please enable your location.": "Om akkurate dienste te lewer, skakel asseblief jou ligging aan.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Laat liggingtoegang toe wanneer dit versoek word. As dit nie versoek word nie, skakel dit aan in jou blaaierinstellings.",
      "🔄 Refresh the page after enabling.": "🔄 Verfris die bladsy nadat dit aangeskakel is.",
      "Enable Now": "Skakel nou aan",
      "Wallet Amount": "Beursiebedrag",
      "Add Amount": "Voeg bedrag by",
      "Enter Amount": "Voer bedrag in",
      "Please enter amount !!": "Voer asseblief bedrag in !!",
      "Partner Rating": "Vennootgradering",
      "Review": "Resensie",
      "comment...": "kommentaar...",
      "SUBMIT": "DIEN IN",
      "Pay from Wallet": "Betaal vanaf beursie",
      "My Wallet": "My beursie",
      "Hire Partner": "Huur vennoot",
      "Message": "Boodskap",
      "Please write message !!": "Skryf asseblief 'n boodskap !!"
    }
  },
  tu: {
    translation: {
      "My Booking": "Rezervasyonum",
      "Saved Addresses": "Kaydedilen Adresler",
      "My Wallet": "Cüzdanım",
      "Refer & Earn": "Davet Et ve Kazan",
      "Contact": "İletişim",
      "About": "Hakkında",
      "Language": "Dil",
      "Privacy Policy": "Gizlilik Politikası",
      "Terms & Condition": "Şartlar ve Koşullar",
      "Logout": "Çıkış Yap",
      "Menu": "Menü",
      "Search for product...": "Ürün ara...",
      "Home services at your": "Evinizdeki hizmetler",
      "doorstep": "kapınızda",
      "What are you looking for?": "Ne arıyorsunuz?",
      "Home": "Ana Sayfa",
      "ReachOut max quantity": "Maksimum miktara ulaşıldı",
      "Please select services !!": "Lütfen hizmetleri seçin!!",
      "item added": "ürün eklendi",
      "VIEW CART": "SEPETİ GÖRÜNTÜLE",
      "Customise your service": "Hizmetinizi özelleştirin",
      "Total Price": "Toplam Fiyat",
      "ADD TO CART": "SEPETE EKLE",
      "ADD": "EKLE",
      "Select a service": "Bir hizmet seçin",
      "Checkout": "Ödeme Yap",
      "Please select date and time !!": "Lütfen tarih ve saat seçin!!",
      "Please select payment method !!": "Lütfen ödeme yöntemini seçin!!",
      "Select Date Of Service": "Hizmet Tarihini Seçin",
      "Select Time Of Service": "Hizmet Saatini Seçin",
      "No time available !!": "Uygun zaman yok!!",
      "Select Address": "Adres Seçin",
      "Change address": "Adresi değiştir",
      "Product list": "Ürün Listesi",
      "Total": "Toplam",
      "Discount": "İndirim",
      "Services list": "Hizmet Listesi",
      "Bill Summary": "Fatura Özeti",
      "Item total": "Ürün Toplamı",
      "Addon Item total": "Ek Ürün Toplamı",
      "Total pay": "Toplam Ödeme",
      "Edit service": "Hizmeti Düzenle",
      "Proceed to pay": "Ödemeye Devam Et",
      "Select Payment Method": "Ödeme Yöntemi Seçin",
      "CONTINUE": "DEVAM ET",
      "Thank you for using our service": "Hizmetimizi kullandığınız için teşekkür ederiz",
      "Your service has been booked successfully.": "Hizmetiniz başarıyla rezerve edildi.",
      "Our team will reach out to you soon.": "Ekibimiz kısa süre içinde sizinle iletişime geçecek.",
      "Continue": "Devam Et",
      "Payment faild !!": "Ödeme başarısız oldu!!",
      "Bookings": "Rezervasyonlar",
      "You added": "Eklediniz",
      "items to booking": "ürün rezervasyona",
      "Booking id": "Rezervasyon ID",
      "Booking date": "Rezervasyon Tarihi",
      "more": "daha fazla",
      "Reschedule": "Yeniden Planla",
      "Cancel": "İptal Et",
      "Bill Total": "Toplam Fatura",
      "Your Services": "Hizmetleriniz",
      "Addon List": "Ek Liste",
      "Time Slot": "Zaman Aralığı",
      "SubTotal": "Ara Toplam",
      "Addon Total": "Ek Toplam",
      "Booking Details": "Rezervasyon Detayları",
      "Payment Method": "Ödeme Yöntemi",
      "Transaction Id": "İşlem Kimliği",
      "Amount Paid": "Ödenen Tutar",
      "CANCEL SERVICE": "HİZMETİ İPTAL ET",
      "Are you sure you want to canceld your service id": "Hizmetinizi iptal etmek istediğinizden emin misiniz?",
      "No": "Hayır",
      "Yes": "Evet",
      "Update": "Güncelle",
      "Booking": "Rezervasyon",
      "Earn": "Kazan",
      "For Each Friend You Refer": "Davet Ettiğiniz Her Arkadaş İçin",
      "Share the Referral Link with Your Friends": "Tavsiye bağlantısını arkadaşlarınızla paylaşın",
      "Friend Gets": "Arkadaşınız Alır",
      "On First Complete Transaction": "İlk Tamamlanan İşlemde",
      "You Get": "Siz Alırsınız",
      "On Your Wallet": "Cüzdanınıza",
      "Text copied to clipboard !!": "Metin panoya kopyalandı!!",
      "Please fill all details !!": "Lütfen tüm bilgileri doldurun!!",
      "SELECT": "SEÇ",
      "EDIT": "DÜZENLE",
      "ADD NEW ADDRESS": "YENİ ADRES EKLE",
      "New Addresses": "Yeni Adresler",
      "Office": "Ofis",
      "Other": "Diğer",
      "Address": "Adres",
      "House / Flat / Block No.": "Ev / Daire / Blok No.",
      "Landmark": "Yer İşareti",
      "Search Product": "Ürün Ara",
      "No search data found !!": "Arama verisi bulunamadı!!",
      "Available Balance": "Mevcut Bakiye",
      "Income": "Gelir",
      "Expense": "Gider",
      "Transaction history": "İşlem Geçmişi",
      "No any transaction history !!": "Hiç işlem geçmişi yok!!",
      "Logout Successfully !!": "Başarıyla çıkış yapıldı!!",
      "Service provider information": "Hizmet sağlayıcı bilgisi",
      "Extra Addon": "Ekstra Eklenti",
      "Full Name": "Tam Adı",
      "Mobile Number": "Mobil Numara",
      "Email Address": "E-posta Adresi",
      "Password": "Şifre",
      "Enter your full name...": "Tam adınızı girin...",
      "Enter your mobile number...": "Mobil numaranızı girin...",
      "Enter your email Address...": "E-posta adresinizi girin...",
      "Enter your password...": "Şifrenizi girin...",
      "Address list not found !!": "Adres listesi bulunamadı!!",
      "Add Address": "Adres Ekle",
      "Search for your location/society/apartment": "Konumunuzu/site/apartmanınızı arayın",
      "Use current location": "Mevcut konumu kullan",
      "Recents": "Son kullanılanlar",
      "We currently do not provide service in your selected area.": "Şu anda seçtiğiniz bölgede hizmet vermiyoruz.",
      "Pages": "Sayfalar",
      "Social links": "Sosyal bağlantılar",
      "Enable Location Services": "Konum Hizmetlerini Etkinleştir",
      "To provide accurate services, please enable your location.": "Doğru hizmetler sunmak için lütfen konumunuzu etkinleştirin.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "İstendiğinde konum erişimine izin verin. İstenmezse, tarayıcı ayarlarınızdan etkinleştirin.",
      "🔄 Refresh the page after enabling.": "🔄 Etkinleştirdikten sonra sayfayı yenileyin.",
      "Enable Now": "Şimdi Etkinleştir",
      "Wallet Amount": "Cüzdan Tutarı",
      "Add Amount": "Tutar Ekle",
      "Enter Amount": "Tutar Girin",
      "Please enter amount !!": "Lütfen tutar girin !!",
      "Partner Rating": "Ortak Puanı",
      "Review": "Yorum",
      "comment...": "yorum...",
      "SUBMIT": "GÖNDER",
      "Pay from Wallet": "Cüzdandan Öde",
      "My Wallet": "Cüzdanım",
      "Hire Partner": "Ortak Tut",
      "Message": "Mesaj",
      "Please write message !!": "Lütfen mesaj yazın !!"

    }
  },
  po: {
    translation: {
      "My Booking": "Minhas Reservas",
      "Saved Addresses": "Endereços Salvos",
      "My Wallet": "Minha Carteira",
      "Refer & Earn": "Indique & Ganhe",
      "Contact": "Contato",
      "About": "Sobre",
      "Language": "Idioma",
      "Privacy Policy": "Política de Privacidade",
      "Terms & Condition": "Termos e Condições",
      "Logout": "Sair",
      "Menu": "Menu",
      "Search for product...": "Buscar produto...",
      "Home services at your": "Serviços domésticos na sua",
      "doorstep": "porta",
      "What are you looking for?": "O que você está procurando?",
      "Home": "Início",
      "ReachOut max quantity": "Quantidade máxima alcançada",
      "Please select services !!": "Por favor, selecione os serviços!!",
      "item added": "item adicionado",
      "VIEW CART": "VER CARRINHO",
      "Customise your service": "Personalize seu serviço",
      "Total Price": "Preço Total",
      "ADD TO CART": "ADICIONAR AO CARRINHO",
      "ADD": "ADICIONAR",
      "Select a service": "Selecione um serviço",
      "Checkout": "Finalizar Compra",
      "Please select date and time !!": "Por favor, selecione data e hora!!",
      "Please select payment method !!": "Por favor, selecione o método de pagamento!!",
      "Select Date Of Service": "Selecione a Data do Serviço",
      "Select Time Of Service": "Selecione o Horário do Serviço",
      "No time available !!": "Nenhum horário disponível!!",
      "Select Address": "Selecione o Endereço",
      "Change address": "Alterar endereço",
      "Product list": "Lista de produtos",
      "Total": "Total",
      "Discount": "Desconto",
      "Services list": "Lista de serviços",
      "Bill Summary": "Resumo da Fatura",
      "Item total": "Total do item",
      "Addon Item total": "Total dos itens adicionais",
      "Total pay": "Total a pagar",
      "Edit service": "Editar serviço",
      "Proceed to pay": "Prosseguir para pagar",
      "Select Payment Method": "Selecione o Método de Pagamento",
      "CONTINUE": "CONTINUAR",
      "Thank you for using our service": "Obrigado por usar nosso serviço",
      "Your service has been booked successfully.": "Seu serviço foi reservado com sucesso.",
      "Our team will reach out to you soon.": "Nossa equipe entrará em contato em breve.",
      "Continue": "Continuar",
      "Payment faild !!": "Pagamento falhou!!",
      "Bookings": "Reservas",
      "You added": "Você adicionou",
      "items to booking": "itens à reserva",
      "Booking id": "ID da reserva",
      "Booking date": "Data da reserva",
      "more": "mais",
      "Reschedule": "Reagendar",
      "Cancel": "Cancelar",
      "Bill Total": "Total da fatura",
      "Your Services": "Seus Serviços",
      "Addon List": "Lista de adicionais",
      "Time Slot": "Horário",
      "SubTotal": "Subtotal",
      "Addon Total": "Total dos adicionais",
      "Booking Details": "Detalhes da reserva",
      "Payment Method": "Método de pagamento",
      "Transaction Id": "ID da transação",
      "Amount Paid": "Valor pago",
      "CANCEL SERVICE": "CANCELAR SERVIÇO",
      "Are you sure you want to canceld your service id": "Tem certeza de que deseja cancelar seu serviço com ID",
      "No": "Não",
      "Yes": "Sim",
      "Update": "Atualizar",
      "Booking": "Reserva",
      "Earn": "Ganhar",
      "For Each Friend You Refer": "Para cada amigo que você indicar",
      "Share the Referral Link with Your Friends": "Compartilhe o link de indicação com seus amigos",
      "Friend Gets": "O amigo recebe",
      "On First Complete Transaction": "Na primeira transação concluída",
      "You Get": "Você recebe",
      "On Your Wallet": "Na sua carteira",
      "Text copied to clipboard !!": "Texto copiado para a área de transferência!!",
      "Please fill all details !!": "Por favor, preencha todos os detalhes!!",
      "SELECT": "SELECIONAR",
      "EDIT": "EDITAR",
      "ADD NEW ADDRESS": "ADICIONAR NOVO ENDEREÇO",
      "New Addresses": "Novos Endereços",
      "Office": "Escritório",
      "Other": "Outro",
      "Address": "Endereço",
      "House / Flat / Block No.": "Casa / Apartamento / Bloco Nº",
      "Landmark": "Ponto de referência",
      "Search Product": "Buscar Produto",
      "No search data found !!": "Nenhum dado encontrado!!",
      "Available Balance": "Saldo disponível",
      "Income": "Renda",
      "Expense": "Despesa",
      "Transaction history": "Histórico de transações",
      "No any transaction history !!": "Nenhum histórico de transações!!",
      "Logout Successfully !!": "Logout realizado com sucesso!!",
      "Service provider information": "Informações do provedor de serviço",
      "Extra Addon": "Adicional Extra",
      "Full Name": "Nome Completo",
      "Mobile Number": "Número de Celular",
      "Email Address": "Endereço de E-mail",
      "Password": "Senha",
      "Enter your full name...": "Digite seu nome completo...",
      "Enter your mobile number...": "Digite seu número de celular...",
      "Enter your email Address...": "Digite seu endereço de e-mail...",
      "Enter your password...": "Digite sua senha...",
      "Address list not found !!": "Lista de endereços não encontrada!!",
      "Add Address": "Adicionar endereço",
      "Search for your location/society/apartment": "Pesquise sua localização/comunidade/apartamento",
      "Use current location": "Usar localização atual",
      "Recents": "Recentes",
      "We currently do not provide service in your selected area.": "Atualmente não oferecemos serviço na área selecionada.",
      "Pages": "Páginas",
      "Social links": "Links sociais",
      "Enable Location Services": "Ativar serviços de localização",
      "To provide accurate services, please enable your location.": "Para fornecer serviços precisos, ative sua localização.",
      "Allow location access when prompted. If not prompted, enable it in your browser settings.": "Permita o acesso à localização quando solicitado. Se não for solicitado, ative nas configurações do seu navegador.",
      "🔄 Refresh the page after enabling.": "🔄 Atualize a página após ativar.",
      "Enable Now": "Ativar agora",
      "Wallet Amount": "Saldo da carteira",
      "Add Amount": "Adicionar valor",
      "Enter Amount": "Inserir valor",
      "Please enter amount !!": "Por favor, insira o valor !!",
      "Partner Rating": "Avaliação do parceiro",
      "Review": "Avaliação",
      "comment...": "comentário...",
      "SUBMIT": "ENVIAR",
      "Pay from Wallet": "Pagar pela carteira",
      "My Wallet": "Minha carteira",
      "Hire Partner": "Contratar parceiro",
      "Message": "Mensagem",
      "Please write message !!": "Por favor, escreva uma mensagem !!"
    }
  },
};

const savedLanguage = secureLocalStorage.getItem('I18') || 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
/* jshint ignore:end */